import React from "react"
import { useSearchParams } from "react-router-dom"
import { Card, Typography, Space } from "antd"
import TotalYearBarChart from "./TotalYearBarChart"
import Spinner from "components/common/Spinner"

import { useTranslation } from "react-i18next"

import { useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import styles from "./TotalYear.module.css"

const { Title } = Typography

export default function TotalYear() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const range = searchParams.get("range")

  const metadata = useSelector(metadataSelector("accounting"))
  const { stats_per_year } = metadata

  return (
    <Card className={styles.totalYearCard}>
      <Space direction="vertical" size="small" className="w-full h-full">
        <Title level={5} className={`fw-normal ${styles.titleMargin}`}>
          {t(`accounting.labels.total_year`)}
        </Title>
        <div className={styles.chartContainer}>
          {stats_per_year ? <TotalYearBarChart range={range} /> : <Spinner className="flex-fill" />}
        </div>
      </Space>
    </Card>
  )
}
